<template>
  <footer class="site-footer">
    <div class="footer-content container">
      <!-- 友情链接列 -->
      <div class="footer-col">
        <h4 class="footer-title">友情链接</h4>
        <ul class="links-list">
          <li v-for="(link, index) in friendLinks" :key="index" class="link-item">
            <a :href="link.url" target="_blank">{{ link.name }}</a>
          </li>
        </ul>
      </div>

      <!-- 联系信息列 -->
      <div class="footer-col">
        <h4 class="footer-title">联系我们</h4>
        <div class="contact-info">
          <p style=" user-select: none;">地址：郑州市经济开发区航海东路1511号</p>
          <p style=" user-select: none;">电话/传真：0371-65959666</p>
          <p style=" user-select: none;">邮箱：hngwjt@zygangwu.com</p>
        </div>
        <!-- <img src="../../assets/img3/lianxiwomen/2.png" /> -->
      </div>

      <!-- 关注我们列 -->
      <div class="footer-col">
        <h4 class="footer-title">关注我们</h4>
        <div class="qrcode-group">
         
          <div class="qrcode-item">
            <img
              src="@/assets/img2/wxgzhNew.jpg"
              alt="官方公众号"
              class="qrcode-img"
            />
            <span>官方公众号</span>
          </div>

          <div class="qrcode-item">
            <img 
              src="@/assets/img2/erweima/50.jpg"
              alt="中豫港务党建"
              class="qrcode-img"
            />
            <span>中豫港务党建</span>
          </div>

        </div>
      </div>
    </div>

    <!-- 版权信息 -->
    <div class="copyright">
      <p><a href="https://beian.miit.gov.cn/" target="_blank">河南中豫国际港务集团有限公司版权所有 豫ICP备20021571号-2</a></p>
    </div>
  </footer>
</template>

<script>
export default {
  data() {
    return {
      friendLinks: [
        { name: '河南省人民政府',  url: 'https://www.henan.gov.cn/'  },
        { name: '河南省政府国资委', url: 'https://gzw.henan.gov.cn/' },
        { name: '郑州市人民政府', url: 'https://www.zhengzhou.gov.cn/' },
        { name: '中欧班列网', url: 'https://www.crexpress.cn/' },
        
        
        // { name: '中央纪委国家监委网站', url: 'https://www.ccdi.gov.cn/' },
        // { name: '河南省纪委监委网站', url: 'https://www.hnsjw.gov.cn/sitesources/hnsjct/page_pc/index.html' },
        
        // { name: '郑州国际陆港',url: 'http://www.zzguojilugang.com/' }
      ]
    }
  }
}
</script>

<style scoped>

.site-footer {
  background: #333;
  color: #fff;
  padding: 40px 0 20px;
}

.footer-content {
  display: flex;
  justify-content: space-between;
  padding-bottom: 10px;
  margin-left: auto; 
  max-width: 90vw; 

}
.footer-content h4,p{
  font-size: 1.2vw;
}
.footer-content ul li{
  font-size: 1vw;
}
.footer-content a{
  font-size: 1.2vw;
}

.footer-col {
  flex: 0 1 30%;
}

.footer-title {
  font-size: 18px;
  margin-bottom: 20px;
  color: #eee;
}

.links-list {
  list-style: none;
  padding: 0;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px 20px;
}

.link-item a {
  color: #ccc;
  text-decoration: none;
  display: block;
  line-height: 1.5;
  transition: color 0.3s;
}

.link-item a:hover {
  color: #fff;
}


.contact-info p {
  margin: 10px 0;
  color: #ccc;
}

.qrcode-group {
  display: flex;
  gap: 20px;
}

.qrcode-item {
  text-align: center;
}

.qrcode-img {
  width: 100px;
  height: 100px;
  display: block;
  margin-bottom: 8px;
}

.copyright {
  text-align: center;
  padding-top: 20px;
  font-size: 14px;
  color: #999;
  
}
.copyright p a{
  color: #ffffff;
  font-size: 1.0vw;
}

@media (max-width: 768px) {
  .footer-content {
    flex-direction: column;
    gap: 30px;
  }
  
  .qrcode-group {
    justify-content: left;
  }

  
  .links-list {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 480px) {
  
  .links-list {
    grid-template-columns: 1fr;
  }
}
</style>